import routes from "./seo.routes.json";

/**
 * Runtime half of the site's SEO configuration.
 *
 * The crawlable route table itself lives in seo.routes.json because the
 * build-time sitemap generator (scripts/generate-sitemap.js) is plain Node
 * and reads the same file off disk. Anything JS-only — helpers, defaults —
 * lives here.
 */

/** Canonical origin. No trailing slash — absUrl() adds the separator. */
export const SITE_URL = routes.siteUrl;

export const SITE_NAME = "bboy creative";

export const DEFAULT_TITLE =
  "bboy creative — A software studio · San Antonio";

export const DEFAULT_DESCRIPTION =
  "bboy creative is a software studio in San Antonio. We build web apps, mobile apps, and MVPs for founders, agencies, and operators. Fixed price. Ships in six weeks.";

/** Absolute OG/Twitter fallback image (1200×630, lives in /public). */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const TWITTER_SITE = "@bboycreative";

/**
 * Every crawlable route that exists at a fixed path, in sitemap order.
 * `changefreq`/`priority` are advisory — Google ignores both, but Bing and a
 * handful of smaller crawlers still read them, and they cost nothing.
 */
export const STATIC_ROUTES = routes.staticRoutes;

/**
 * Routes that must never be indexed: authenticated shells and the login page.
 * Mirrored as Disallow rules in public/robots.txt — robots.txt stops the
 * crawl, the meta tag stops indexing of anything that leaks past it.
 */
export const PRIVATE_PATH_PREFIXES = routes.privatePathPrefixes;

/** Join a path onto the canonical origin. Accepts absolute URLs unchanged. */
export const absUrl = (path = "/") => {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  const clean = path.startsWith("/") ? path : `/${path}`;
  // Strip a trailing slash so "/work/" and "/work" don't canonicalize apart.
  const trimmed = clean.length > 1 ? clean.replace(/\/+$/, "") : clean;
  return `${SITE_URL}${trimmed}`;
};

/** Collapse markup/whitespace and clip to a meta-description-sized string. */
export const toDescription = (input, max = 160) => {
  const text = String(input || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (text.length <= max) return text;
  // Cut on a word boundary so the snippet doesn't end mid-word.
  return `${text.slice(0, max - 1).replace(/\s+\S*$/, "")}…`;
};

/** Firestore Timestamp | Date | string → "YYYY-MM-DD", or null if unparseable. */
export const toISODate = (value) => {
  if (!value) return null;
  const d = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(d?.getTime?.()) ? null : d.toISOString().slice(0, 10);
};
